import { NavLink, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, BookOpen, ShoppingCart, Mail, Users, Ticket, Settings, LogOut, UserCog, KeyRound, Send } from "lucide-react";
import Logo from "@/components/Logo";
import { hasAccess } from "@/lib/roles";

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  if (loading) return <div className="p-12 text-navy/60">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (!hasAccess(user.role, "admin")) return <Navigate to="/" replace />;

  const items = [
    { to: "/admin", i: LayoutDashboard, label: "Dashboard", end: true },
    { to: "/admin/ebooks", i: BookOpen, label: "Ebooks" },
    { to: "/admin/orders", i: ShoppingCart, label: "Orders" },
    { to: "/admin/subscribers", i: Mail, label: "Subscribers" },
    { to: "/admin/emails", i: Send, label: "Emails" },
    { to: "/admin/affiliates", i: Users, label: "Affiliates" },
    { to: "/admin/coupons", i: Ticket, label: "Coupons" },
    { to: "/admin/users", i: UserCog, label: "Users" },
    { to: "/admin/settings", i: Settings, label: "Settings" },
  ];
  return (
    <div className="min-h-screen flex bg-[#F7F5F0]">
      <aside className="w-64 bg-navy text-white flex flex-col p-6" data-testid="admin-sidebar">
        <div className="mb-10 flex items-center gap-3">
          <Logo size={36} color="#F7F5F0" />
          <div>
            <div className="font-serif text-2xl">Aperture</div>
            <div className="eyebrow" style={{ color: "#C4A265", fontSize: "0.55rem" }}>Admin Console</div>
          </div>
        </div>
        <nav className="flex-1 space-y-1">
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end} data-testid={`admin-nav-${it.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm transition-colors duration-300 ${isActive ? "bg-gold text-navy" : "text-white/70 hover:text-gold"}`}>
              <it.i className="w-4 h-4" strokeWidth={1.5} /> {it.label}
            </NavLink>
          ))}
        </nav>
        <NavLink to="/change-password" data-testid="admin-nav-change-password" className="flex items-center gap-3 px-3 py-2.5 text-sm text-white/60 hover:text-gold transition-colors">
          <KeyRound className="w-4 h-4" /> Change my password
        </NavLink>
        <button onClick={logout} data-testid="admin-logout" className="flex items-center gap-3 px-3 py-2.5 text-sm text-white/60 hover:text-gold transition-colors">
          <LogOut className="w-4 h-4" /> Sign out
        </button>
      </aside>
      <main className="flex-1 p-10 overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
}
